import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiCircleCreditService extends ApiClass {

  constructor() {
    super();
    // No establecemos un path base ya que los endpoints son directos
  }

  // PF Format endpoints - URLs corregidas para coincidir con el backend
  findAllPFFormat(filters: any): Observable<any> {
    return this.postCollection(filters, 'pf-format/find-all');
  }

  getPFFormat(id: string): Observable<any> {
    const result = this.getCollection(id, environment.apiUrl, 'pf-format');
    return result;
  }

  updatePFFormat(id: string, data: any): Observable<any> {
    return this.putCollection(data, environment.apiUrl, `pf-format/${id}`);
  }

  deletePFFormat(id: string): Observable<any> {
    return this.deleteCollection(id, environment.apiUrl, 'pf-format');
  }

  // PM Format endpoints - URLs corregidas para coincidir con el backend
  findAllPMFormat(filters: any): Observable<any> {
    return this.postCollection(filters, 'pm-format/find-all');
  }

  getPMFormat(id: string): Observable<any> {
    const result = this.getCollection(id, environment.apiUrl, 'pm-format');
    return result;
  }

  updatePMFormat(id: string, data: any): Observable<any> {
    return this.putCollection(data, environment.apiUrl, `pm-format/${id}`);
  }

  deletePMFormat(id: string): Observable<any> {
    return this.deleteCollection(id, environment.apiUrl, 'pm-format');
  }

  // Método para descargar reporte de círculo de crédito
  downloadReport(id: string): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}credit-circle/reports/${id}`, {
      responseType: 'blob'
    }).pipe(
      catchError((error) => {
        console.error('Error al descargar reporte de círculo de crédito:', error);
        throw error;
      })
    );
  }
}
